/**
 * Bayedi 2026 Zip Perde Fiyat Listesi — Matris Verileri
 * Kaynak: Kullanıcı tarafından sağlanan Bayedi fiyat görüntüleri (5 görüntü)
 *
 * Modeller: T100 (maks h=400cm), T125 (maks h=600cm)
 * Kumaşlar: Serge Ferrari (serge), Helioscreen (helio)
 * Fiyatlar: EUR, adet başına (m² değil)
 * Ölçü adımı: 25cm
 */

// ── BYD100 — Serge Ferrari ────────────────────────────────────────────────────
// Maks: 6m genişlik × 4m yükseklik
// Kaynak: Görüntü 3 (utea3hdk) — AI analizörü tarafından BYD100 SERGE FERRARI olarak doğrulandı
const BYD100_SERGE = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400],
  prices: [
    //  w→ 100   125   150   175   200   225   250   275   300   325   350   375   400   425   450   475   500   525   550   575   600
    [  459,  494,  530,  566,  602,  636,  672,  708,  743,  779,  815,  850,  886,  922,  958,  993, 1029, 1064, 1099, 1135, 1171], // h=100
    [  485,  524,  563,  602,  640,  679,  718,  757,  796,  835,  874,  912,  951,  990, 1029, 1068, 1107, 1145, 1184, 1223, 1262], // h=125
    [  512,  554,  596,  638,  680,  722,  764,  806,  848,  890,  932,  974, 1016, 1058, 1100, 1142, 1184, 1226, 1268, 1310, 1352], // h=150
    [  539,  584,  629,  674,  719,  765,  811,  856,  901,  946,  991, 1036, 1081, 1127, 1172, 1217, 1262, 1308, 1353, 1399, 1444], // h=175
    [  566,  614,  662,  711,  759,  807,  856,  905,  953, 1002, 1050, 1098, 1147, 1195, 1243, 1292, 1341, 1389, 1437, 1486, 1534], // h=200
    [  592,  644,  696,  748,  800,  850,  902,  953, 1006, 1057, 1109, 1160, 1212, 1263, 1316, 1367, 1418, 1470, 1521, 1574, 1625], // h=225
    [  619,  674,  729,  783,  838,  893,  948, 1003, 1057, 1113, 1168, 1222, 1277, 1332, 1387, 1442, 1496, 1552, 1606, 1661, 1716], // h=250
    [  646,  703,  762,  820,  879,  937,  994, 1052, 1110, 1169, 1226, 1284, 1342, 1401, 1458, 1516, 1575, 1633, 1690, 1748, 1807], // h=275
    [  673,  734,  795,  857,  918,  979, 1040, 1101, 1162, 1224, 1285, 1346, 1408, 1469, 1530, 1592, 1653, 1714, 1775, 1836, 1897], // h=300
    [  699,  763,  828,  892,  957, 1022, 1086, 1151, 1215, 1279, 1344, 1408, 1473, 1537, 1601, 1666, 1730, 1795, 1859, 1924, 1989], // h=325
    [  725,  794,  861,  929,  963,  996, 1065, 1132, 1200, 1267, 1334, 1403, 1470, 1538, 1605, 1674, 1745, 1815, 1887, 1957, 2029], // h=350
    [  753,  823,  895,  965, 1001, 1036, 1107, 1178, 1248, 1320, 1390, 1462, 1532, 1603, 1674, 1745, 1815, 1891, 1964, 2039, 2113], // h=375
    [  781,  852,  929, 1001, 1039, 1076, 1149, 1224, 1296, 1373, 1446, 1521, 1594, 1668, 1743, 1816, 1885, 1967, 2041, 2121, 2197], // h=400
  ],
};

// ── BYD100 — Helioscreen ──────────────────────────────────────────────────────
// Maks: 6m genişlik × 4m yükseklik
// Kaynak: Görüntü 4 (xkhvxd3q) — AI analizörü tarafından BYD100 HELIO olarak doğrulandı
const BYD100_HELIO = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400],
  prices: [
    //  w→ 100   125   150   175   200   225   250   275   300   325   350   375   400   425   450   475   500   525   550   575   600
    [  430,  459,  488,  517,  545,  573,  602,  631,  659,  688,  716,  745,  774,  802,  830,  859,  888,  917,  945,  973, 1003], // h=100
    [  450,  480,  510,  541,  570,  601,  630,  660,  691,  720,  751,  780,  811,  841,  870,  901,  931,  961,  991, 1021, 1051], // h=125
    [  470,  502,  533,  565,  596,  628,  659,  690,  721,  753,  784,  816,  847,  879,  910,  942,  973, 1005, 1036, 1068, 1099], // h=150
    [  489,  523,  555,  588,  622,  654,  688,  720,  753,  786,  819,  851,  885,  918,  950,  984, 1016, 1050, 1082, 1115, 1149], // h=175
    [  509,  544,  578,  612,  647,  681,  716,  750,  784,  819,  854,  887,  922,  956,  991, 1025, 1059, 1094, 1128, 1162, 1197], // h=200
    [  529,  565,  601,  636,  672,  709,  744,  780,  816,  851,  887,  923,  959,  994, 1031, 1067, 1102, 1138, 1174, 1210, 1245], // h=225
    [  549,  586,  624,  660,  698,  735,  773,  809,  847,  884,  922,  959,  996, 1033, 1071, 1108, 1145, 1182, 1220, 1257, 1295], // h=250
    [  568,  607,  646,  685,  723,  762,  801,  840,  878,  917,  955,  994, 1035, 1072, 1111, 1150, 1187, 1226, 1265, 1304, 1343], // h=275
    [  588,  628,  669,  709,  749,  790,  829,  869,  909,  950,  990, 1030, 1070, 1111, 1151, 1191, 1231, 1271, 1311, 1351, 1391], // h=300
    [  608,  650,  691,  733,  775,  816,  858,  899,  941,  983, 1024, 1066, 1108, 1149, 1191, 1232, 1274, 1316, 1357, 1399, 1441], // h=325
    [  628,  671,  714,  757,  800,  843,  886,  929,  972, 1015, 1058, 1101, 1144, 1187, 1231, 1274, 1317, 1360, 1403, 1446, 1489], // h=350
    [  648,  692,  736,  781,  825,  869,  914,  959, 1004, 1048, 1092, 1137, 1181, 1226, 1270, 1315, 1360, 1404, 1449, 1493, 1537], // h=375
    [  667,  713,  759,  805,  850,  897,  943,  989, 1034, 1080, 1127, 1173, 1218, 1264, 1310, 1357, 1403, 1448, 1494, 1540, 1586], // h=400
  ],
};

// ── BYD125 — Serge Ferrari ────────────────────────────────────────────────────
// Maks: 6m genişlik × 6m yükseklik
// Kaynak: Görüntü 1 (imep80f5) — BYD125 Serge Ferrari tam matris
const BYD125_SERGE = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  prices: [
    //  w→  100   125   150   175   200   225   250   275   300   325   350   375   400   425   450   475   500   525   550   575   600
    [  440,  472,  506,  539,  572,  605,  638,  671,  704,  737,  771,  803,  837,  869,  903,  935,  969, 1003, 1035, 1069, 1101], // h=100
    [  466,  503,  539,  575,  611,  648,  685,  720,  757,  793,  829,  865,  902,  939,  974, 1011, 1047, 1084, 1119, 1156, 1193], // h=125
    [  493,  532,  572,  611,  651,  691,  730,  770,  809,  848,  888,  927,  967, 1007, 1046, 1086, 1126, 1164, 1203, 1243, 1283], // h=150
    [  520,  563,  605,  648,  691,  733,  776,  819,  861,  904,  947,  990, 1032, 1075, 1118, 1160, 1203, 1246, 1288, 1331, 1374], // h=175
    [  546,  592,  638,  685,  730,  776,  822,  868,  913,  960, 1006, 1052, 1097, 1143, 1190, 1235, 1281, 1327, 1373, 1418, 1465], // h=200
    [  573,  623,  672,  720,  770,  819,  868,  917,  966, 1015, 1065, 1114, 1162, 1212, 1261, 1310, 1359, 1408, 1457, 1507, 1556], // h=225
    [  599,  652,  704,  757,  809,  862,  913,  966, 1018, 1071, 1123, 1176, 1227, 1280, 1332, 1385, 1437, 1490, 1541, 1594, 1646], // h=250
    [  627,  682,  738,  794,  848,  904,  960, 1015, 1071, 1126, 1182, 1238, 1292, 1348, 1404, 1459, 1515, 1571, 1626, 1682, 1738], // h=275
    [  653,  712,  771,  829,  888,  947, 1006, 1065, 1123, 1182, 1241, 1300, 1359, 1416, 1475, 1534, 1593, 1652, 1710, 1769, 1828], // h=300
    [  680,  742,  804,  866,  928,  990, 1052, 1114, 1176, 1238, 1300, 1362, 1424, 1486, 1548, 1610, 1672, 1733, 1795, 1857, 1919], // h=325
    [  707,  772,  837,  902,  967, 1032, 1098, 1163, 1228, 1294, 1359, 1424, 1489, 1554, 1620, 1684, 1749, 1814, 1879, 1945, 2010], // h=350
    [  734,  802,  870,  939, 1007, 1075, 1143, 1212, 1280, 1349, 1417, 1486, 1554, 1622, 1690, 1759, 1827, 1895, 1963, 2032, 2101], // h=375
    [  760,  832,  903,  975, 1047, 1118, 1190, 1261, 1332, 1404, 1476, 1548, 1619, 1690, 1762, 1833, 1903, 1977, 2048, 2120, 2191], // h=400
    [  787,  862,  937, 1011, 1086, 1161, 1236, 1310, 1384, 1459, 1535, 1610, 1684, 1759, 1833, 1908, 1983, 2058, 2132, 2207, 2283], // h=425
    [  814,  891,  970, 1048, 1126, 1203, 1282, 1360, 1437, 1515, 1594, 1672, 1749, 1827, 1906, 1983, 2059, 2139, 2218, 2295, 2373], // h=450
    [  841,  922, 1003, 1084, 1165, 1246, 1327, 1409, 1490, 1571, 1653, 1733, 1814, 1895, 1977, 2058, 2139, 2221, 2302, 2382, 2464], // h=475
    [  867,  951, 1036, 1120, 1204, 1289, 1373, 1457, 1542, 1626, 1711, 1795, 1879, 1964, 2048, 2132, 2218, 2302, 2386, 2471, 2555], // h=500
    [  895,  982, 1069, 1157, 1244, 1332, 1420, 1507, 1595, 1682, 1770, 1857, 1945, 2033, 2120, 2208, 2295, 2382, 2471, 2558, 2646], // h=525
    [  921, 1011, 1102, 1193, 1284, 1374, 1466, 1556, 1647, 1738, 1828, 1919, 2010, 2101, 2191, 2283, 2373, 2464, 2555, 2646, 2736], // h=550
    [  947, 1042, 1135, 1229, 1323, 1417, 1511, 1605, 1699, 1793, 1887, 1981, 2075, 2169, 2263, 2357, 2451, 2545, 2639, 2733, 2827], // h=575
    [  974, 1071, 1169, 1266, 1363, 1460, 1557, 1655, 1751, 1849, 1946, 2043, 2141, 2237, 2335, 2432, 2529, 2626, 2724, 2822, 2918], // h=600
  ],
};

// ── BYD125 — Helioscreen ──────────────────────────────────────────────────────
// Maks: 6m genişlik × 6m yükseklik
// Kaynak: Görüntü 2 (ofxpf6ly) — BYD125 Helioscreen tam matris
const BYD125_HELIO = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  prices: [
    //  w→  100   125   150   175   200   225   250   275   300   325   350   375   400   425   450   475   500   525   550   575   600
    [  412,  438,  464,  489,  515,  542,  568,  594,  619,  646,  672,  698,  724,  751,  776,  802,  828,  855,  881,  907,  932], // h=100
    [  431,  459,  486,  513,  541,  569,  596,  624,  651,  678,  707,  734,  761,  788,  817,  844,  871,  899,  926,  954,  982], // h=125
    [  450,  480,  509,  538,  567,  595,  625,  653,  682,  712,  740,  770,  798,  827,  857,  885,  914,  943,  972, 1002, 1030], // h=150
    [  470,  501,  531,  562,  592,  623,  653,  683,  714,  744,  775,  805,  836,  866,  897,  927,  958,  988, 1017, 1048, 1078], // h=175
    [  490,  522,  554,  586,  617,  650,  681,  713,  745,  777,  808,  841,  872,  904,  937,  968, 1000, 1032, 1064, 1095, 1128], // h=200
    [  510,  543,  576,  610,  644,  676,  710,  743,  776,  809,  843,  877,  909,  943,  976, 1009, 1043, 1076, 1110, 1142, 1176], // h=225
    [  529,  565,  599,  634,  669,  703,  738,  773,  807,  842,  877,  912,  947,  982, 1016, 1051, 1086, 1120, 1155, 1190, 1224], // h=250
    [  549,  586,  622,  658,  694,  731,  766,  803,  839,  876,  911,  947,  984, 1019, 1056, 1092, 1129, 1167, 1201, 1237, 1274], // h=275
    [  569,  607,  645,  682,  719,  757,  795,  832,  870,  908,  946,  983, 1027, 1058, 1096, 1135, 1174, 1210, 1246, 1284, 1322], // h=300
    [  589,  628,  670,  706,  745,  784,  823,  862,  902,  941,  980, 1018, 1058, 1097, 1135, 1176, 1217, 1257, 1298, 1339, 1370], // h=325
    [  609,  649,  690,  730,  771,  812,  851,  892,  932,  973, 1014, 1054, 1095, 1135, 1176, 1217, 1257, 1298, 1339, 1379, 1420], // h=350
    [  628,  670,  712,  754,  796,  838,  880,  922,  964, 1006, 1048, 1090, 1132, 1174, 1216, 1258, 1300, 1342, 1384, 1426, 1468], // h=375
    [  648,  691,  735,  778,  822,  865,  908,  952,  995, 1038, 1082, 1126, 1169, 1213, 1256, 1300, 1343, 1386, 1430, 1473, 1516], // h=400
    [  668,  713,  757,  802,  847,  892,  937,  982, 1027, 1072, 1116, 1161, 1206, 1252, 1298, 1341, 1386, 1431, 1475, 1520, 1565], // h=425
    [  688,  734,  780,  826,  872,  919,  965, 1012, 1058, 1105, 1151, 1197, 1243, 1289, 1336, 1382, 1429, 1475, 1521, 1568, 1614], // h=450
    [  707,  755,  802,  850,  898,  946,  993, 1042, 1089, 1137, 1184, 1233, 1280, 1328, 1375, 1424, 1471, 1519, 1567, 1615, 1662], // h=475
    [  727,  776,  825,  875,  924,  973, 1022, 1071, 1120, 1170, 1219, 1268, 1318, 1367, 1415, 1465, 1514, 1563, 1612, 1662, 1711], // h=500
    [  746,  797,  847,  899,  949, 1000, 1051, 1101, 1152, 1204, 1254, 1304, 1354, 1405, 1456, 1507, 1557, 1607, 1659, 1709, 1760], // h=525
    [  766,  818,  870,  923,  974, 1027, 1079, 1131, 1183, 1235, 1287, 1340, 1391, 1444, 1496, 1548, 1600, 1653, 1704, 1757, 1808], // h=550
    [  786,  840,  893,  947, 1001, 1054, 1108, 1161, 1215, 1268, 1322, 1375, 1429, 1483, 1536, 1590, 1643, 1697, 1750, 1804, 1857], // h=575
    [  805,  861,  916,  970, 1026, 1080, 1136, 1191, 1245, 1301, 1355, 1411, 1466, 1520, 1576, 1631, 1686, 1741, 1795, 1851, 1906], // h=600
  ],
};

// ── BYD125 — Transparan ───────────────────────────────────────────────────────
// Maks: 7m genişlik × 6m yükseklik (50cm adımlar)
// Kaynak: Kullanıcı tarafından yüklenen Bayedi BYD Fiyatlar PDF (byd fiyatlar.pdf)
const BYD125_TRANSPARAN = {
  widths:  [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700],
  heights: [100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600],
  prices: [
    //  w→  100   150   200   250   300   350   400   450   500   550   600   650   700
    [  463,  542,  622,  700,  780,  859,  939, 1017, 1097, 1177, 1256, 1336, 1414], // h=100
    [  520,  613,  708,  801,  895,  989, 1082, 1176, 1269, 1364, 1457, 1551, 1645], // h=150
    [  576,  685,  793,  902, 1010, 1118, 1226, 1334, 1443, 1551, 1659, 1767, 1875], // h=200
    [  634,  756,  879, 1002, 1124, 1247, 1370, 1493, 1616, 1738, 1861, 1983, 2106], // h=250
    [  691,  827,  965, 1102, 1239, 1376, 1514, 1651, 1788, 1926, 2062, 2200, 2337], // h=300
    [  748,  900, 1051, 1202, 1354, 1506, 1658, 1809, 1961, 2113, 2264, 2416, 2567], // h=350
    [  804,  971, 1137, 1303, 1469, 1635, 1802, 1968, 2134, 2299, 2466, 2632, 2798], // h=400
    [  862, 1043, 1223, 1404, 1584, 1765, 1946, 2126, 2307, 2487, 2668, 2849, 3029], // h=450
    [  919, 1114, 1308, 1504, 1699, 1894, 2089, 2284, 2479, 2674, 2870, 3064, 3259], // h=500
    [  975, 1177, 1376, 1575, 1775, 1975, 2175, 2376, 2576, 2776, 2976, 3176, 3376], // h=550
    [ 1032, 1256, 1479, 1699, 1929, 2152, 2376, 2601, 2824, 3049, 3280, 3490, 3721], // h=600
  ],
};

// ── Model / Kumaş Haritalama ──────────────────────────────────────────────────
export const BAYEDI_MATRICES = {
  "T100": { "serge": BYD100_SERGE, "helio": BYD100_HELIO },
  "T125": { "serge": BYD125_SERGE, "helio": BYD125_HELIO, "transparan": BYD125_TRANSPARAN },
};

/** Kumaş markasından kumaş ailesi çıkartır (Artbey ile aynı mantık) */
export function resolveBayediFabricFamily(fabricBrand) {
  const b = (fabricBrand || "").toLowerCase();
  if (!b) return null;
  if (b.includes("serge")) return "serge";
  if (b.includes("helio") || b.includes("copaco")) return "helio";
  if (b.includes("transparan") || b.includes("transparent")) return "transparan";
  return null;
}

/** Bayedi Zip fiyatı — matris araması (yukarı yuvarlama mantığı) */
function interpolate(m, wCm, hCm) {
  const maxW = m.widths[m.widths.length - 1];
  const maxH = m.heights[m.heights.length - 1];
  if (wCm > maxW || hCm > maxH || wCm < m.widths[0] || hCm < m.heights[0]) {
    return { price: null, isRedZone: false, outOfRange: true };
  }
  let wi = m.widths.findIndex(v => v >= wCm);
  if (wi < 0) wi = m.widths.length - 1;
  let hi = m.heights.findIndex(v => v >= hCm);
  if (hi < 0) hi = m.heights.length - 1;
  const price = m.prices[hi][wi];
  const trace = { w: m.widths[wi], h: m.heights[hi], cellPrice: price };
  return { price, isRedZone: false, outOfRange: false, trace };
}

/**
 * Bayedi Zip fiyat araması
 * @param {string} model       "T100" | "T125"
 * @param {string} fabricBrand Kumaş markası (Serge Ferrari / Helioscreen)
 * @param {number} wCm         Genişlik (cm)
 * @param {number} hCm         Yükseklik (cm)
 */
export function lookupBayediZipPrice(model, fabricBrand, wCm, hCm) {
  const family = resolveBayediFabricFamily(fabricBrand);
  const m = BAYEDI_MATRICES[model]?.[family] || null;
  if (!m) return { price: null, isRedZone: false, outOfRange: false, noMatrix: true, family, model };
  return {
    ...interpolate(m, wCm, hCm),
    noMatrix: false,
    family,
    model,
    wCm,
    hCm,
    source: "static",
    matrixName: `${model} — ${family === "serge" ? "Serge Ferrari" : family === "transparan" ? "Transparan" : "Helioscreen"}`,
    matrixId: null,
  };
}
